import { render, staticRenderFns } from "./exportOrderRecords.vue?vue&type=template&id=9047170e&scoped=true"
import script from "./exportOrderRecords.vue?vue&type=script&lang=js"
export * from "./exportOrderRecords.vue?vue&type=script&lang=js"
import style0 from "./exportOrderRecords.vue?vue&type=style&index=0&id=9047170e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9047170e",
  null
  
)

export default component.exports